import { render, staticRenderFns } from "./VerifyEmailView.vue?vue&type=template&id=1ef9a70e&scoped=true"
import script from "./VerifyEmailView.vue?vue&type=script&lang=js"
export * from "./VerifyEmailView.vue?vue&type=script&lang=js"
import style0 from "./VerifyEmailView.vue?vue&type=style&index=0&id=1ef9a70e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef9a70e",
  null
  
)

export default component.exports